import ClientDetails from "./ui/ui";

export default ClientDetails;
